import { AJOUTE_CRENEAU, SUPRIMER_CRENEAU } from '../types/typeCreneau';
const creneau = [];
const CreneauReducer = (state = creneau, action) => {
    if (localStorage.getItem('creneau')) {
        state = JSON.parse(localStorage.getItem('creneau'));
    }
    switch (action.type) {
        case AJOUTE_CRENEAU:
            state = action.payload;
            return state;
            break;
        case SUPRIMER_CRENEAU:
            return state = [];
        default:
            return state;

    }
}

export default CreneauReducer;